import AdminAddPasein from "../../components/AdminPasien/AdminPasienAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
